import styled from "styled-components";
import React from "react";
import { NumberText } from "./Introduce";
import { UIGrid, UIList } from "../../UI/List";
import { musics, sports } from "../../Layouts/Header";
import { Link } from "react-router-dom";

export const CategorySection = () => {
  return (
    <div className="bs-container">
      <Styles>
        <NumberText style={{ color: "#111423" }}>02</NumberText>
        <h2>DANH SÁCH HẠNG MỤC</h2>
        <div className="category-content">
          <h3>LĨNH VỰC ÂM NHẠC</h3>
          <UIList items={musics} className="grid-cover">
            {(item) => {
              return (
                <div className="item">
                  <Link to={item.href} style={{ background: "none", padding: "0 0"}}>
                  <div className="image-cover">
                    <img src={item.image} />
                  </div>
                  <div className="sub-text">Hạng mục</div>
                  <div className="label-text">{item.label}</div>
                  <div>
                    <Link to={item.href}>Bình chọn ngay</Link>
                  </div>
                  </Link>
                </div>
              );
            }}
          </UIList>
        </div>

        <div className="category-content sport">
          <h3>LĨNH VỰC THỂ THAO</h3>
          <UIList items={sports} className="grid-cover">
            {(item) => {
              return (
                <div className="item">
                  <Link to={item.href} style={{ background: "none", padding:"0 0"}}>
                  <div className="image-cover">
                    <img src={item.image} />
                  </div>
                  <div className="sub-text">Hạng mục</div>
                  <div className="label-text">{item.label}</div>
                  <div>
                    <Link to={item.href}>Bình chọn ngay</Link>
                  </div>
                  </Link>
                </div>
              );
            }}
          </UIList>
        </div>
      </Styles>
    </div>
  );
};

const Styles = styled.div`
  margin: 80px 0;
  h2 {
    margin: 0 0 40px;
    font-size: 40px;
    font-weight: 700;
  }

  .category-content {
    background: rgba(29, 34, 52, 0.65);
    border-radius: 16px;
    padding: 20px 40px 40px;
  }

  h3 {
    font-size: 32px;
    color: #be8eff;
    margin: 0 0 28px;
    text-align: center;
    font-weight: 700;
  }

  .grid-cover {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    gap: 30px;
    > div {
      width: 30%;
    }
  }

  .item {
    padding: 16px 16px 32px;
    background-color: #2a3045;
    border-radius: 8px;
    text-align: center;

    .image-cover {
      max-width: 310x;
      max-height: 310px;
      overflow: hidden;
      border-radius: 12px;
    }

    img {
      width: 100%;
      transition: 0.3s;
    }

    .sub-text {
      margin: 20px 0 4px;
    }

    .label-text {
      font-size: 16px;
      font-weight: 700;
      text-transform: uppercase;
    }

    a {
      background: #373f58;
      padding: 8px 24px;
      border-radius: 12px;
      color: #a5bfd7;
      margin: 0 auto;
      margin: 20px auto 0;
      display: block;
      width: fit-content;

      :hover {
        background: linear-gradient(94.08deg, #a15bff 0%, #ff8a5a 100%);
        color: white;
      }
    }

    :hover {
      box-shadow: 3px 3px 20px #a15bff55, -3px -3px 20px #a15bff55;
      img {
        transform: scale(1.03);
      }
    }
  }

  .category-content.sport {
    margin-top: 60px;
    h3 {
      color: #d4ef85;
    }
  }

  @media only screen and (max-width: 768px) {
    .category-content {
      padding: 20px 15px 40px;
    }
    .grid-cover {
      > div {
        width: 45%;
      }
    }
  }

  @media only screen and (max-width: 480px) {
    h2 {
      font-size: 24px;
    }

    h3 {
      font-size: 20px;
    }
    .grid-cover {
      > div {
        width: 100%;
      }
    }
  }
`;
